import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "home-echarts-header",
  style: {"padding":"10px 24px 0 24px","height":"auto"}
}
const _hoisted_2 = { class: "home-echarts-header__title" }
const _hoisted_3 = { class: "home-echarts-header__controls" }

import { ref, onBeforeMount, watch } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import type { Ref, PropType } from 'vue'
import { getCustomerStageDataBoard } from '@/api/gucangSales/dataBoard'
import { colors } from '../dataConfig'


const __default__ = { name: 'CustomerStageStatus' }

interface ItemCommonType {
  name: string
  quantity: number,
  total: number,
  prop: string
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String as PropType<string>,
    default: '客户阶段状态'
  },
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    required: true
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '350px'
  },
  marginBottom: {
    type: String as PropType<string>,
    default: '8px'
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  formState: {
    type: Object as PropType<Object>
  }
},
  setup(__props) {

const props = __props

const spinning = ref(false)
const showECharts = ref(false)
const stage = ref(2)
const getData = () => {
  const queryForm = {
    ...props.formState,
    stage: stage.value
  }
  spinning.value = true
  getCustomerStageDataBoard(queryForm)
    .then((res:any) => {
      const data = res.data?.statusList as unknown as ItemCommonType[]
      if (!data || data.length === 0) {
        showECharts.value = false
        initChart([])
      } else {
        showECharts.value = true
        data.forEach((item) => {
          item.percent = (item?.total ? Number((((item.quantity ?? 0) / item.total) * 100).toFixed(2)) : 0)
          return item
        })
        initChart(data)
      }
    })
    .finally(() => {
      spinning.value = false
    })
}
watch(() => props.formState, (val) => {
  getData()
})

const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>, undefined, false)
const initChart = (data: ItemCommonType[]) => {
  setOptions({
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      right: 'left',
      bottom: 'center',
      top: 'middle',
      icon: 'circle',
      // left: 'right',
      // align: 'left', // 文字位置
      padding: [0, 30],
      formatter: (val) => {
        const quality = data.find((item) => item.name === val)?.quantity
        const arr = [
          '{b|' + val + '}',
          '{c|' + quality + '}'
        ]
        return arr.join(' ')
      },
      textStyle: {
        align: 'right',
        rich: {
          b: {
            color: '#6E7B91',
            fontSize: '12px'
          },
          c: {
            fontWeight: 'bold',
            color: '#6E7B91',
            fontSize: '16px'
          }
        }
      }
    },
    series: [
      {
        type: 'pie',
        radius: '76%',
        labelLayout: {
          hideOverlap: false
        },
        bottom: 15,
        right: 150,
        minAngle: 1,
        data: data.map((item, index) => ({
          value: item.quantity,
          name: item.name,
          prop: item.prop,
          label: {
            show: item.percent && item.percent > 10,
            position: 'inside',
            color: '#fff',
            /// 如果需要设置字体 可以添加 textStyle: {color:'', fontsize: ''}
            formatter: (val) => {
              return val.data?.name + '\n' + val.data?.prop
            },
            emphasis: {
              show: true // 鼠标悬浮时显示标签
            }
          },
          itemStyle: {
            color: index < colors.length ? colors[index] : undefined
          }
        })),
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  })
}
onBeforeMount(() => getData())

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", {
    class: "home-echarts-wrap",
    style: _normalizeStyle({ width: __props.width, height: __props.height, marginBottom: __props.marginBottom})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CosSelect, {
          value: stage.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((stage).value = $event)),
          allowClear: props.allowClear,
          style: {"width":"145px","margin-left":"10px"},
          onChange: getData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select_option, { value: 2 }, {
              default: _withCtx(() => [
                _createTextVNode("潜在")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 3 }, {
              default: _withCtx(() => [
                _createTextVNode("签约")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 4 }, {
              default: _withCtx(() => [
                _createTextVNode("成交")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "allowClear"])
      ])
    ]),
    _createVNode(_component_a_spin, {
      spinning: spinning.value,
      delay: 200
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "home-echarts-content"
        }, null, 512), [
          [_vShow, showECharts.value]
        ]),
        (!showECharts.value)
          ? (_openBlock(), _createBlock(_component_dc_layout_empty, {
              key: 0,
              type: "nothing"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["spinning"])
  ], 4))
}
}

})